import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { 
  FaArrowLeft, FaBox, FaTruck, FaUser, FaMapMarkerAlt, 
  FaFileInvoice, FaCreditCard, FaShippingFast, FaCalendarAlt, 
  FaTag, FaExclamationCircle, FaCheckCircle, FaTimesCircle, 
  FaReceipt, FaExchangeAlt, FaInfoCircle, FaEnvelope, 
  FaPrint, FaDownload, FaClock, FaBars, FaPhone, FaStoreAlt
} from 'react-icons/fa';
import './OrderDetails.css';
import { useTranslation } from 'react-i18next';

// Dummy data for "experience" role - detailed orders
const dummyExperienceOrderDetailsList = [
  { 
    id: 'exp_ord_1', order_number: 'EXP1001', created_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(), 
    customer: { name: 'John Experience', email: 'john.exp@example.com', phone: '555-0101', orders_count: 3, total_spent: '150.00', first_name: 'John', last_name: 'Experience' },
    line_items: [
      { id: 'li_exp001_1', title: 'Galaxy T-Shirt', quantity: 1, price: '29.99', sku: 'EXP-TS-GAL-M-BLK', variant_title: 'M / Cosmic Black', total_discount: '0.00' },
      { id: 'li_exp001_2', title: 'Astro Mug', quantity: 1, price: '15.99', sku: 'EXP-MUG-AST-STD', variant_title: 'Standard', total_discount: '0.00' }
    ],
    total_price: '45.98', subtotal_price: '45.98', total_discounts: '0.00', total_shipping: '5.00', total_tax: '2.30',
    financial_status: 'paid', fulfillment_status: 'fulfilled', 
    source_marketplace: 'Unanimity Marketplace',
    billing_address: { name: 'John Experience', address1: '123 Exp Lane', address2: '', city: 'Testville', province_code: 'TS', zip: '12345', country: 'US', phone: '555-0101'},
    shipping_address: { name: 'John Experience', address1: '123 Exp Lane', address2: '', city: 'Testville', province_code: 'TS', zip: '12345', country: 'US', phone: '555-0101'},
    payment_details: { credit_card_company: 'Visa Exp', credit_card_number: '•••• 4242' },
    shipping_lines: [{ title: 'Standard Shipping', price: '5.00', carrier_identifier: 'exp_carrier_std', delivery_category: 'Standard' }],
    fulfillments: [{ created_at: new Date(Date.now() - 20 * 60 * 60 * 1000).toISOString(), status: 'fulfilled', tracking_company: 'UPS Exp', tracking_number: '1ZEXP001UPS', tracking_url: '#' }],
    tracking: [{ tracking_company: 'UPS Exp', tracking_number: '1ZEXP001UPS', tracking_url: '#', status: 'delivered', tracking_details: { status_description: 'Delivered', estimated_delivery: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(), events: [{ timestamp: new Date().toISOString(), description: 'Package delivered', location: 'Front Door'}] } }],
    refunds: [], note: 'Fragile items, handle with care.', tags: ['VIP', 'Expedited'], cancelled_at: null, cancel_reason: null
  },
  { 
    id: 'exp_ord_2', order_number: 'EXP1002', created_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(), 
    customer: { name: 'Jane Demo', email: 'jane.demo@example.com', phone: '555-0202', orders_count: 1, total_spent: '49.99', first_name: 'Jane', last_name: 'Demo' },
    line_items: [{ id: 'li_exp002_1', title: 'Nebula Hoodie', quantity: 1, price: '49.99', sku: 'EXP-HOOD-NEB-M-BLU', variant_title: 'M / Cosmic Blue', total_discount: '5.00' }],
    total_price: '44.99', subtotal_price: '49.99', total_discounts: '5.00', total_shipping: '0.00', total_tax: '0.00',
    financial_status: 'pending', fulfillment_status: 'unfulfilled', 
    source_marketplace: 'Amazon DE',
    billing_address: { name: 'Jane Demo', address1: '456 Demo Ave', city: 'Mockซิตี้', province_code: 'MC', zip: '67890', country: 'DE'},
    shipping_address: { name: 'Jane Demo', address1: '456 Demo Ave', city: 'Mockซิตี้', province_code: 'MC', zip: '67890', country: 'DE'},
    shipping_lines: [{ title: 'Free Shipping', price: '0.00' }],
    refunds: [], note: 'Gift message: Happy Birthday!', cancelled_at: null
  },
    { 
    id: 'exp_ord_3', order_number: 'EXP1003', created_at: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(), 
    customer: { name: 'Test User Alpha', email: 'alpha.test@example.com', phone: '555-0303', orders_count: 10, total_spent: '500.00', first_name: 'Test', last_name: 'Alpha'},
    line_items: [{ id: 'li_exp003_1', title: 'Rocket Cap', quantity: 2, price: '19.99', sku: 'EXP-CAP-RCK-OS', variant_title: 'One Size', total_discount: '0.00' }],
    total_price: '39.98', subtotal_price: '39.98', total_discounts: '0.00', total_shipping: '7.50', total_tax: '1.50',
    financial_status: 'paid', fulfillment_status: 'partially_fulfilled', 
    source_marketplace: 'Shopify Store',
    billing_address: { name: 'Test User Alpha', address1: '789 Alpha Rd', city: 'Alphaville', province_code: 'AL', zip: '11223', country: 'CA'},
    shipping_address: { name: 'Test User Alpha', address1: '789 Alpha Rd', city: 'Alphaville', province_code: 'AL', zip: '11223', country: 'CA'},
    payment_details: { credit_card_company: 'MasterCard Exp', credit_card_number: '•••• 5555' },
    shipping_lines: [{ title: 'Express Shipping', price: '7.50' }],
    fulfillments: [{ created_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(), status: 'partially_fulfilled', tracking_company: 'FedEx Exp', tracking_number: 'FXEXP003FEDEX', tracking_url: '#' }],
    tracking: [{ tracking_company: 'FedEx Exp', tracking_number: 'FXEXP003FEDEX', tracking_url: '#', status: 'in_transit', tracking_details: { status_description: 'In transit', estimated_delivery: new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).toISOString(), events: [] } }],
    refunds: [], tags: ['Repeat Customer']
  },
];

const OrderDetails = () => {
  const [order, setOrder] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedItems, setSelectedItems] = useState({});
  const [showRefundModal, setShowRefundModal] = useState(false);
  const [refundNote, setRefundNote] = useState('');
  const [notifyCustomer, setNotifyCustomer] = useState(true);
  const [refundError, setRefundError] = useState(null);
  const [activeTab, setActiveTab] = useState('items');
  const { orderId } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const fetchOrderDetails = async (isSimulatedUpdate = false) => {
    // If it's a simulated update for an experience user, don't re-fetch,
    // as the 'order' state is already updated locally by handleRefund.
    if (isSimulatedUpdate) return;

    try {
      setIsLoading(true);
      setError(null);
      const token = sessionStorage.getItem('access_token');
      const userDataString = sessionStorage.getItem('userData');
      let userRole = null;
      let isAdmin = false;

      if (!token) {
          navigate('/');
          setIsLoading(false);
          return;
      }

      if (userDataString) {
        try {
          const userData = JSON.parse(userDataString);
          userRole = userData.role;
          isAdmin = userRole === 'admin';
        } catch (parseError) {
          console.error("Failed to parse user data from sessionStorage:", parseError);
        }
      }

      if (userRole === 'experience') {
        console.log(`Experience user detected. Looking for dummy order detail with ID: ${orderId}`);
        const dummyOrder = dummyExperienceOrderDetailsList.find(o => o.id === orderId);
        if (dummyOrder) {
          setOrder(dummyOrder);
        } else {
          console.warn(`Dummy order detail with ID ${orderId} not found.`);
          setError(t('orderDetails.errorNotFoundExperience', 'This experience order detail is not available.'));
          setOrder(null);
        }
        setIsLoading(false);
        return;
      }

      let endpoint;
      if (isAdmin) {
        endpoint = `/api/shopify/get_local_order/${orderId}`;
        console.log("Admin user detected, fetching details from local order endpoint:", endpoint);
      } else {
        endpoint = `/api/shopify/get_order/${orderId}`;
        console.log("Non-admin user or role unknown, fetching details from Shopify order endpoint:", endpoint);
      }

      const response = await axios.get(endpoint, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data) {
        setOrder(response.data);
      } else {
         console.warn("Order details data not found in expected format:", response.data);
         setOrder(null);
         setError(t('orderDetails.errorNotFound'));
      }

    } catch (err) {
      console.error("Error fetching order details:", err);
      setError(err.response?.data?.detail || err.message || t('orderDetails.errorLoading'));
      setOrder(null);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (order && order.id === orderId && sessionStorage.getItem('userRoleForOrderDetails') === 'experience') {
      // If it's an experience user and the order is already loaded (e.g. after simulated refund), don't re-fetch.
      // This relies on setting a temporary session item or a more robust state management.
      // For simplicity, we might still re-fetch dummy data which is fine.
      // The more robust solution is in handleRefund not calling fetchOrderDetails for experience user.
    } else {
      fetchOrderDetails();
    }
  }, [orderId, t, navigate]); // Removed 'order' from dependencies to avoid re-fetch loops after local state update

  const handleRefund = async () => {
    try {
      setRefundError(null);
      const token = sessionStorage.getItem('access_token');
      const userDataString = sessionStorage.getItem('userData');
      let userRole = null;
      if (userDataString) {
          try {
              userRole = JSON.parse(userDataString).role;
          } catch (e) { console.error("Error parsing user data for refund:", e); }
      }

      const lineItemsToRefund = Object.entries(selectedItems)
        .filter(([_, quantity]) => quantity > 0)
        .map(([id, quantity]) => ({
          line_item_id: order.line_items.find(item => item.id === id)?.id_original || parseInt(id, 10), // Use original ID if available
          quantity: quantity,
          restock_type: "NO_RESTOCK" // Default or make it configurable
        }));

      if (lineItemsToRefund.length === 0) {
        setRefundError(t('orderDetails.errorSelectItems'));
        return;
      }
      
      const totalRefundAmount = Object.entries(selectedItems)
        .filter(([_, quantity]) => quantity > 0)
        .reduce((total, [id, quantity]) => {
            const item = order.line_items.find(i => i.id === id);
            return total + (item ? quantity * parseFloat(item.price) : 0);
        }, 0);


      if (userRole === 'experience') {
        console.log("Simulating refund for experience user.");
        
        const newRefund = {
          id: `ref_${Date.now()}`, // Dummy refund ID
          created_at: new Date().toISOString(),
          note: refundNote,
          total_price: totalRefundAmount.toFixed(2),
          refund_line_items: lineItemsToRefund.map(li => { // Store which items were refunded
            const originalItem = order.line_items.find(item => (item.id_original || item.id) === li.line_item_id);
            return { ...originalItem, quantity: li.quantity, id: li.line_item_id }; // or a simpler summary
          })
        };

        const updatedOrder = {
          ...order,
          refunds: [...(order.refunds || []), newRefund],
          financial_status: totalRefundAmount >= parseFloat(order.total_price) ? 'refunded' : 'partially_refunded'
        };
        setOrder(updatedOrder); // Update local state directly

        setShowRefundModal(false);
        setSelectedItems({});
        setRefundNote('');
        // Do NOT call fetchOrderDetails() here for experience user to keep the simulated state
        alert(t('orderDetails.refundSuccessSimulated', 'Refund simulated successfully!'));
        return;
      }

      // Real API call for other users
      const refundData = {
        order_id: parseInt(orderId, 10),
        refund_line_items: lineItemsToRefund,
        note: refundNote,
        notify: notifyCustomer,
        // Potentially add currency if API requires
      };

      await axios.post('/api/shopify/create_refund', refundData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      setShowRefundModal(false);
      setSelectedItems({});
      setRefundNote('');
      fetchOrderDetails(); // Re-fetch real order details after successful refund
    } catch (err) {
      console.error("Refund creation failed:", err.response?.data || err.message);
      setRefundError(err.response?.data?.detail || err.message || t('orderDetails.refundFailedError'));
    }
  };

  const getStatusIcon = (status) => {
    if (!status) return <FaInfoCircle className="status-icon status-neutral" />;
    
    switch (status.toLowerCase()) {
      case 'paid':
      case 'fulfilled':
        return <FaCheckCircle className="status-icon status-success" />;
      case 'pending':
      case 'partially_fulfilled':
        return <FaClock className="status-icon status-pending" />;
      case 'unfulfilled':
      case 'refunded':
      case 'partially_refunded':
      case 'voided':
        return <FaTimesCircle className="status-icon status-danger" />;
      default:
        return <FaInfoCircle className="status-icon status-neutral" />;
    }
  };

  const getStatusClass = (status) => {
    if (!status) return 'una-status-neutral';
    
    switch (status.toLowerCase()) {
      case 'paid':
      case 'fulfilled':
        return 'una-status-success';
      case 'pending':
      case 'partially_fulfilled':
        return 'una-status-pending';
      case 'unfulfilled':
      case 'refunded':
      case 'partially_refunded':
      case 'voided':
        return 'una-status-danger';
      default:
        return 'una-status-neutral';
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const options = { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const renderItemsList = () => (
    <div className="una-items-list">
      {order.line_items.map((item) => (
        <div key={item.id} className="una-item">
          <div className="una-item-checkbox-order">
            <input
              type="checkbox"
              checked={selectedItems[item.id] > 0}
              onChange={(e) => {
                setSelectedItems({
                  ...selectedItems,
                  [item.id]: e.target.checked ? item.quantity : 0
                });
              }}
            />
          </div>
          <div className="una-item-content">
            <div className="una-item-details">
              <h4>{item.title}</h4>
              <div className="una-item-meta">
                <span>SKU: {item.sku || 'N/A'}</span>
                {item.variant_title && <span>Variant: {item.variant_title}</span>}
              </div>
              {selectedItems[item.id] > 0 && (
                <div className="una-quantity-control">
                  <label>{t('orderDetails.refundQuantity')}</label>
                  <input
                    type="number"
                    min="1"
                    max={item.quantity}
                    value={selectedItems[item.id]}
                    onChange={(e) => {
                      setSelectedItems({
                        ...selectedItems,
                        [item.id]: parseInt(e.target.value) || 0
                      });
                    }}
                  />
                </div>
              )}
            </div>
            <div className="una-item-info">
              <div className="una-item-quantity">
                <span>{t('orderDetails.qtyPrefix')}: {item.quantity}</span>
              </div>
              <div className="una-item-price">
                ${parseFloat(item.price).toFixed(2)}
              </div>
              {item.total_discount > 0 && (
                <div className="una-discount">
                  -{parseFloat(item.total_discount).toFixed(2)}
                </div>
              )}
              <div className="una-item-total">
                ${((item.price * item.quantity) - item.total_discount).toFixed(2)}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  const renderRefundModal = () => (
    showRefundModal && (
      <div className="una-modal-overlay">
        <div className="una-modal">
          <div className="una-modal-header">
            <h2>{t('orderDetails.createRefundModalTitle')}</h2>
            <button 
              className="una-modal-close" 
              onClick={() => setShowRefundModal(false)}
            >
              ×
            </button>
          </div>
          {refundError && (
            <div className="una-error">
              <FaExclamationCircle /> {refundError}
            </div>
          )}
          <div className="una-modal-content">
            <div className="una-modal-summary">
              <h3>{t('orderDetails.refundSummary')}</h3>
              <div className="una-refund-items">
                {Object.entries(selectedItems)
                  .filter(([_, quantity]) => quantity > 0)
                  .map(([id, quantity]) => {
                    const item = order.line_items.find(item => item.id === id);
                    return item ? (
                      <div key={id} className="una-refund-item">
                        <div>{item.title}</div>
                        <div>
                          {quantity} × ${parseFloat(item.price).toFixed(2)} = ${(quantity * item.price).toFixed(2)}
                        </div>
                      </div>
                    ) : null;
                  })
                }
              </div>
              <div className="una-refund-total">
                <span>{t('orderDetails.totalRefund')}</span>
                <span>
                  ${Object.entries(selectedItems)
                    .filter(([_, quantity]) => quantity > 0)
                    .reduce((total, [id, quantity]) => {
                      const item = order.line_items.find(item => item.id === id);
                      return total + (item ? quantity * item.price : 0);
                    }, 0).toFixed(2)}
                </span>
              </div>
            </div>
            <div className="una-form-group">
              <label htmlFor="refund-note">{t('orderDetails.refundNoteLabel')}</label>
              <textarea
                id="refund-note"
                placeholder={t('orderDetails.refundNotePlaceholder')}
                value={refundNote}
                onChange={(e) => setRefundNote(e.target.value)}
              />
            </div>
            <div className="una-form-group una-checkbox-group">
              <label>
                <input
                  type="checkbox"
                  checked={notifyCustomer}
                  onChange={(e) => setNotifyCustomer(e.target.checked)}
                />
                <div className="una-checkbox-label">
                  <FaEnvelope />
                  <span>{t('orderDetails.notifyCustomer')}</span>
                </div>
              </label>
            </div>
          </div>
          <div className="una-modal-actions">
            <button className="una-btn-cancel" onClick={() => setShowRefundModal(false)}>
              {t('orderDetails.cancel')}
            </button>
            <button className="una-btn-confirm" onClick={handleRefund}>
              {t('orderDetails.processRefund')}
            </button>
          </div>
        </div>
      </div>
    )
  );

  if (error) return (
    <div className="una-order-details-container">
      <button className="una-back-button" onClick={() => navigate('/orders')}>
        <FaArrowLeft /> {t('orderDetails.backToOrders')}
      </button>
      <div className="una-error-container">
        <FaExclamationCircle />
        <h2>{t('orderDetails.errorLoading')}</h2>
        <p>{error}</p>
        <button className="una-retry-button" onClick={fetchOrderDetails}>
          {t('orderDetails.tryAgain')}
        </button>
      </div>
    </div>
  );
  
  if (isLoading) {
    return (
      <div className="una-order-details-container">
        <button className="una-back-button" onClick={() => navigate('/orders')}>
          <FaArrowLeft /> {t('orderDetails.backToOrders')}
        </button>
        <div className="una-dashboard-loading-screen">
        <div className="una-loading-content">
          <div className="una-loading-logo">
            <img src="/bgless_logo.png" alt="Unanimity AI Logo" />
          </div>
            <h2>{t('orderDetails.loadingTitle')}</h2>
            <div className="una-loading-progress">
              <div className="una-progress-bar">
                <div className="una-progress-glow"></div>
              </div>
            </div>
            <div className="una-loading-metrics">
              <div className="una-metric-item">
                <FaFileInvoice />
                <span>{t('orderDetails.loadingInfo')}</span>
              </div>
              <div className="una-metric-item">
                <FaBox />
                <span>{t('orderDetails.loadingItems')}</span>
              </div>
              <div className="una-metric-item">
                <FaTruck />
                <span>{t('orderDetails.loadingShipping')}</span>
              </div>
              <div className="una-metric-item">
                <FaCreditCard />
                <span>{t('orderDetails.loadingPayment')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!order) {
    return (
      <div className="una-order-details-container">
        <button className="una-back-button" onClick={() => navigate('/orders')}>
          <FaArrowLeft /> {t('orderDetails.backToOrders')}
        </button>
        <div className="una-error-container">
          <FaExclamationCircle />
          <h2>{t('orderDetails.errorNotFoundTitle', 'Order Not Found')}</h2>
          <p>{error || t('orderDetails.errorNotFound')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="una-order-details-container">
      <div className="una-order-details-header">
        <button className="una-back-button" onClick={() => navigate('/orders')}>
          <FaArrowLeft /> {t('orderDetails.backToOrders')}
        </button>
        
        <div className="una-order-actions">
          <button className="una-action-button">
            <FaPrint /> {t('orderDetails.print')}
          </button>
          <button className="una-action-button">
            <FaDownload /> {t('orderDetails.export')}
          </button>
        </div>
      </div>

      <div className="una-order-overview">
        <div className="una-order-title">
          <h1>{t('orderDetails.order')} #{order.name || order.order_number || order.id}</h1>
          <div className="una-order-date">
            <FaCalendarAlt />
            <span>{formatDate(order.created_at)}</span>
          </div>
        </div>
        
        <div className="una-order-status-section">
          <div className="una-status-group">
            <div className="una-status-label">{t('orderDetails.payment')}</div>
            <div className={`una-status-pill ${getStatusClass(order.financial_status)}`}>
              {getStatusIcon(order.financial_status)}
              <span>{order.financial_status}</span>
            </div>
          </div>
          
          <div className="una-status-group">
            <div className="una-status-label">{t('orderDetails.fulfillment')}</div>
            <div className={`una-status-pill ${getStatusClass(order.fulfillment_status || 'unfulfilled')}`}>
              {getStatusIcon(order.fulfillment_status)}
              <span>{order.fulfillment_status || t('orderDetails.unfulfilled')}</span>
            </div>
          </div>
          
          {order.cancelled_at && (
            <div className="una-status-group">
              <div className="una-status-label">{t('orderDetails.orderStatus')}</div>
              <div className="una-status-pill una-status-danger">
                <FaTimesCircle className="status-icon status-danger" />
                <span>{t('orderDetails.cancelled')}</span>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="una-order-tabs">
        <button 
          className={`una-tab ${activeTab === 'items' ? 'active' : ''}`}
          onClick={() => setActiveTab('items')}
        >
          <FaBox /> {t('orderDetails.itemsPaymentTab')}
        </button>
        <button 
          className={`una-tab ${activeTab === 'customer' ? 'active' : ''}`}
          onClick={() => setActiveTab('customer')}
        >
          <FaUser /> {t('orderDetails.customerInfoTab')}
        </button>
        <button 
          className={`una-tab ${activeTab === 'shipping' ? 'active' : ''}`}
          onClick={() => setActiveTab('shipping')}
        >
          <FaTruck /> {t('orderDetails.shippingDetailsTab')}
        </button>
        {order.note && (
          <button 
            className={`una-tab ${activeTab === 'notes' ? 'active' : ''}`}
            onClick={() => setActiveTab('notes')}
          >
            <FaFileInvoice /> {t('orderDetails.notesTab')}
          </button>
        )}
      </div>

      <div className="una-order-tab-content">
        {activeTab === 'items' && (
          <div className="una-tab-panel">
            <div className="una-panel-header">
              <h2><FaBox /> {t('orderDetails.orderItems')}</h2>
              {!order.cancelled_at && (
                <button 
                  className="una-refund-button"
                  onClick={() => setShowRefundModal(true)}
                  disabled={Object.values(selectedItems).every(v => v === 0)}
                >
                  <FaExchangeAlt /> {t('orderDetails.createRefund')}
                </button>
              )}
            </div>

            <div className="una-items-card">
              <div className="una-items-table-header">
                <div className="una-th-checkbox"></div>
                <div className="una-th-product">{t('orderDetails.product')}</div>
                <div className="una-th-quantity">{t('orderDetails.quantity')}</div>
                <div className="una-th-price">{t('orderDetails.price')}</div>
                <div className="una-th-discount">{t('orderDetails.discount')}</div>
                <div className="una-th-total">{t('orderDetails.total')}</div>
              </div>
              {renderItemsList()}
            </div>

            <div className="una-order-summary-card">
              <h3><FaReceipt /> {t('orderDetails.orderSummary')}</h3>
              <div className="una-summary-grid">
                <div className="una-summary-section">
                  <div className="una-summary-group">
                    <div className="una-summary-row">
                      <span>{t('orderDetails.subtotal')}</span>
                      <span>${parseFloat(order.subtotal_price).toFixed(2)}</span>
                    </div>
                    
                    {order.total_discounts > 0 && (
                      <div className="una-summary-row discount">
                        <span>{t('orderDetails.discounts')}</span>
                        <span>-${parseFloat(order.total_discounts).toFixed(2)}</span>
                      </div>
                    )}
                    
                    {order.total_shipping > 0 && (
                      <div className="una-summary-row">
                        <span>{t('orderDetails.shipping')}</span>
                        <span>${parseFloat(order.total_shipping).toFixed(2)}</span>
                      </div>
                    )}
                    
                    {order.total_tax > 0 && (
                      <div className="una-summary-row">
                        <span>{t('orderDetails.tax')}</span>
                        <span>${parseFloat(order.total_tax).toFixed(2)}</span>
                      </div>
                    )}
                  </div>
                </div>
                
                <div className="una-total-section">
                  <div className="una-total-row">
                    <span>{t('orderDetails.total')}</span>
                    <span>${parseFloat(order.total_price).toFixed(2)}</span>
                  </div>
                  
                  {order.financial_status === 'paid' && (
                    <div className="una-total-row paid">
                      <span>{t('orderDetails.paidByCustomer')}</span>
                      <span>${parseFloat(order.total_price).toFixed(2)}</span>
                    </div>
                  )}
                  
                  {order.refunds && order.refunds.length > 0 && (
                    <div className="una-total-row refunded">
                      <span>{t('orderDetails.refunded')}</span>
                      <span>-${order.refunds.reduce((sum, refund) => 
                        sum + parseFloat(refund.total_price || 0), 0).toFixed(2)}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
            
            {order.payment_details && (
              <div className="una-payment-card">
                <h3><FaCreditCard /> {t('orderDetails.paymentDetails')}</h3>
                <div className="una-payment-info">
                  <div className="una-payment-method">
                    <strong>{t('orderDetails.method')}</strong> {order.payment_details.credit_card_company || t('orderDetails.creditCard')}
                  </div>
                  {order.payment_details.credit_card_number && (
                    <div className="una-payment-card-number">
                      <strong>{t('orderDetails.card')}</strong> •••• {order.payment_details.credit_card_number}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        {activeTab === 'customer' && order.customer && (
          <div className="una-tab-panel">
            <div className="una-panel-header">
              <h2><FaUser /> {t('orderDetails.customerInformation')}</h2>
            </div>
            
            <div className="una-customer-card">
              <div className="una-customer-details">
                <div className="una-customer-avatar">
                  {(order.customer.name || '').charAt(0) || 
                   (order.customer.email || '').charAt(0) || 'G'}
                </div>
                <div className="una-customer-info">
                  <h3>{order.customer.name || `${order.customer.first_name || ''} ${order.customer.last_name || ''}`.trim() || t('orderDetails.guestCustomer')}</h3>
                  <div className="una-customer-contact">
                    {order.customer.email && (
                      <div className="una-customer-email">
                        <FaEnvelope />
                        <span>{order.customer.email}</span>
                      </div>
                    )}
                    {order.customer.phone && (
                      <div className="una-customer-phone">
                        <FaPhone />
                        <span>{order.customer.phone}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              
              {order.customer.orders_count > 0 && (
                <div className="una-customer-stats">
                  <div className="una-stat">
                    <span className="una-stat-value">{order.customer.orders_count}</span>
                    <span className="una-stat-label">{t('orderDetails.ordersStat')}</span>
                  </div>
                  {order.customer.total_spent && (
                    <div className="una-stat">
                      <span className="una-stat-value">${parseFloat(order.customer.total_spent).toFixed(2)}</span>
                      <span className="una-stat-label">{t('orderDetails.totalSpentStat')}</span>
                    </div>
                  )}
                </div>
              )}
              
              {order.billing_address && (
                <div className="una-address-section">
                  <h3><FaReceipt /> {t('orderDetails.billingAddress')}</h3>
                  <div className="una-address">
                    <p>{order.billing_address.name}</p>
                    <p>{order.billing_address.address1}</p>
                    {order.billing_address.address2 && <p>{order.billing_address.address2}</p>}
                    <p>{order.billing_address.city}, {order.billing_address.province_code} {order.billing_address.zip}</p>
                    <p>{order.billing_address.country}</p>
                    {order.billing_address.phone && <p>{t('orderDetails.phone')} {order.billing_address.phone}</p>}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {activeTab === 'shipping' && (
          <div className="una-tab-panel">
            <div className="una-panel-header">
              <h2><FaTruck /> {t('orderDetails.shippingDetails')}</h2>
            </div>
            
            {order.shipping_address && (
              <div className="una-shipping-card">
                <h3><FaMapMarkerAlt /> {t('orderDetails.shippingAddress')}</h3>
                <div className="una-address">
                  <p>{order.shipping_address.name}</p>
                  <p>{order.shipping_address.address1}</p>
                  {order.shipping_address.address2 && <p>{order.shipping_address.address2}</p>}
                  <p>{order.shipping_address.city}, {order.shipping_address.province_code} {order.shipping_address.zip}</p>
                  <p>{order.shipping_address.country}</p>
                  {order.shipping_address.phone && <p>{t('orderDetails.phone')} {order.shipping_address.phone}</p>}
                </div>
              </div>
            )}

            {order.shipping_label_url && (
              <div className="una-shipping-card">
                <h3><FaPrint /> {t('orderDetails.shippingLabel')}</h3>
                <div className="una-shipping-label-action">
                  <a 
                    href={order.shipping_label_url} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="una-action-button"
                  >
                    <FaDownload /> {t('orderDetails.viewDownloadLabel')}
                  </a>
                </div>
              </div>
            )}

            {(order.shipping_lines && (Array.isArray(order.shipping_lines) ? order.shipping_lines.length > 0 : order.shipping_lines.title)) && (
              <div className="una-shipping-card">
                <h3><FaShippingFast /> {t('orderDetails.shippingMethod')}</h3>
                {Array.isArray(order.shipping_lines) ? 
                  order.shipping_lines.map((line, index) => (
                    <div key={index} className="una-shipping-method">
                      <div className="una-shipping-method-details">
                        <div className="una-shipping-method-name">{line.title}</div>
                        {line.carrier_identifier && (
                          <div className="una-shipping-carrier">{line.carrier_identifier}</div>
                        )}
                        {line.delivery_category && (
                          <div className="una-shipping-category">{line.delivery_category}</div>
                        )}
                      </div>
                      <div className="una-shipping-price">${parseFloat(line.price).toFixed(2)}</div>
                    </div>
                  )) : (
                    <div className="una-shipping-method">
                      <div className="una-shipping-method-details">
                        <div className="una-shipping-method-name">{order.shipping_lines.title}</div>
                        {order.shipping_lines.code && (
                          <div className="una-shipping-carrier">{order.shipping_lines.code}</div>
                        )}
                      </div>
                      <div className="una-shipping-price">${parseFloat(order.shipping_lines.price || 0).toFixed(2)}</div>
                    </div>
                  )
                }
              </div>
            )}
            
            {order.fulfillments && order.fulfillments.length > 0 && (
              <div className="una-shipping-card">
                <h3><FaBox /> {t('orderDetails.fulfillment')}</h3>
                {order.fulfillments.map((fulfillment, index) => (
                  <div key={index} className="una-fulfillment">
                    <div className="una-fulfillment-header">
                      <div className={`una-status-pill ${getStatusClass(fulfillment.status)}`}>
                        {getStatusIcon(fulfillment.status)}
                        <span>{fulfillment.status}</span>
                      </div>
                      <div className="una-fulfillment-date">
                        <FaCalendarAlt />
                        <span>{formatDate(fulfillment.created_at)}</span>
                      </div>
                    </div>
                    
                    {fulfillment.tracking_number && (
                      <div className="una-tracking-info">
                        <div className="una-tracking-number">
                          <strong>{t('orderDetails.tracking')}</strong> {fulfillment.tracking_number}
                        </div>
                        {fulfillment.tracking_company && (
                          <div className="una-tracking-company">
                            <strong>{t('orderDetails.carrier')}</strong> {fulfillment.tracking_company}
                          </div>
                        )}
                        {fulfillment.tracking_url && (
                          <a 
                            href={fulfillment.tracking_url} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="una-tracking-link"
                          >
                            {t('orderDetails.trackPackage')}
                          </a>
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}

            {order.tracking && order.tracking.length > 0 && (
              <div className="una-shipping-card">
                <h3><FaShippingFast /> {t('orderDetails.trackingDetails')}</h3>
                {order.tracking.map((track, index) => (
                  <div key={index} className="una-tracking-detail-container">
                    <div className="una-tracking-detail-header">
                      <div className={`una-status-pill ${getStatusClass(track.status)}`}>
                        {getStatusIcon(track.status)}
                        <span>{track.status}</span>
                      </div>
                      <div className="una-tracking-info-summary">
                        <div className="una-tracking-number">
                          <strong>{t('orderDetails.tracking')}:</strong> {track.tracking_number}
                        </div>
                        {track.tracking_company && (
                          <div className="una-tracking-company">
                            <strong>{t('orderDetails.carrier')}:</strong> {track.tracking_company}
                          </div>
                        )}
                      </div>
                      {track.tracking_url && (
                        <a 
                          href={track.tracking_url} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="una-tracking-link"
                        >
                          {t('orderDetails.trackPackage')}
                        </a>
                      )}
                    </div>
                    
                    {track.tracking_details && (
                      <div className="una-tracking-timeline">
                        {track.tracking_details.events && track.tracking_details.events.length > 0 ? (
                          <>
                            <div className="una-timeline-current-status">
                              <FaInfoCircle />
                              <span>{track.tracking_details.status || t('orderDetails.inTransit')}</span>
                            </div>
                            <div className="una-timeline-events">
                              {track.tracking_details.events.map((event, eventIndex) => (
                                <div key={eventIndex} className="una-timeline-event">
                                  <div className="una-timeline-dot"></div>
                                  <div className="una-timeline-content">
                                    <div className="una-timeline-date">
                                      {formatDate(event.timestamp)}
                                    </div>
                                    <div className="una-timeline-description">
                                      {event.description}
                                    </div>
                                    {event.location && (
                                      <div className="una-timeline-location">
                                        <FaMapMarkerAlt />
                                        <span>{event.location}</span>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </>
                        ) : (
                          <div className="una-no-tracking-events">
                            <FaInfoCircle />
                            <span>{t('orderDetails.noTrackingEvents')}</span>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {activeTab === 'notes' && (order.note || (Array.isArray(order.tags) && order.tags.length > 0)) && (
           <div className="una-tab-panel">
               {order.note && (
                  <div className="una-notes-card">
                     <div className="una-note">
                        <div className="una-note-content">
                           {order.note}
                        </div>
                     </div>
                  </div>
               )}
                {Array.isArray(order.tags) && order.tags.length > 0 && (
                  <div className="una-tags-section">
                    <h3><FaTag /> {t('orderDetails.tags')}</h3>
                    <div className="una-tags">
                      {order.tags.map((tag, index) => (
                        <span key={index} className="una-tag">
                          {tag.trim()}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
                {order.cancelled_at && (
                  <div className="una-cancelled-card">
                    <h3><FaTimesCircle /> {t('orderDetails.cancellationDetails')}</h3>
                    <div className="una-cancelled-info">
                      <div className="una-cancelled-date">
                        <strong>{t('orderDetails.cancelledOn')}</strong> {formatDate(order.cancelled_at)}
                      </div>
                      {order.cancel_reason && (
                        <div className="una-cancelled-reason">
                          <strong>{t('orderDetails.reason')}</strong> {order.cancel_reason}
                        </div>
                      )}
                    </div>
                  </div>
                )}
           </div>
         )}
      </div>

      {renderRefundModal()}
    </div>
  );
};

export default OrderDetails;